export const HabilitarGoogleRecaptcha =
  process.env.HabilitarGoogleRecaptcha || false;
export const HabilitarLoginAutomatico =
  process.env.HabilitarLoginAutomatico || true;
export const HabilitarSSE = false; //dejar este valor en false
export const HabilitarFireBase = process.env.HabilitarFireBase || true;
export const HabilitarPooling = false;
const ProduccionDesarrollo = process.env.ProduccionDesarrollo || "P";

let SERVER_IP = "";
let HttpHttps = "";

/*produccion*/
if (ProduccionDesarrollo === "P") {
  SERVER_IP = "localpoint-dev-server-1c6c4ca64539.herokuapp.com";
  HttpHttps = "https";
}

/*desarrollo*/
if (ProduccionDesarrollo === "D") {
  SERVER_IP = process.env.SERVER_IP || "localhost:3977";
  HttpHttps = "http";
}

export const ENTORNO = {
  GOOGLE_MAPS_APIKEY:
    process.env.GOOGLE_MAPS_APIKEY || "AIzaSyAMqRtQO0710z-o3NJGNXZtCpfUBObWJe4",

  firebaseConfig: {
    apiKey: process.env.apiKey || "AIzaSyA-R591xBno_OZL4hmogPWJFZt_mOxH8z4",
    authDomain: process.env.authDomain || "local-point-c8974.firebaseapp.com",
    projectId: process.env.projectId || "local-point-c8974",
    storageBucket: process.env.storageBucket || "local-point-c8974.appspot.com",
    messagingSenderId: process.env.messagingSenderId || "257554526566",
    appId: process.env.appId || "1:257554526566:web:6e7fd8f3a38743ae9018a7",
    measurementId: process.env.measurementId || "G-G6BE6K6QRX",
  },

  vapidKey:
    process.env.vapidKey ||
    "BAnKLQ7kmB7r9Y_OSoEvdCvfM3xygYjxwudeRRZRZ_KAWHUv61J0r2p2juenLVJ1Tx8qXt-M5jYtxs4Mg8kwAXM",

  ADICIONAL_LOCALPOINT: process.env.ADICIONAL_LOCALPOINT || 1.3, //porcentaje local point

  GOOGLE_RECAPTCHA_V3_SITEKEY:
    process.env.GOOGLE_RECAPTCHA_V3_SITEKEY ||
    "6LeaRqMpAAAAALI6OFAzf4b5kPC5fZG_ub0-YNAk",

  // URL_SERVIDOR_SSE:
  //   ProduccionDesarrollo === "D"
  //     ? "http://localhost:3977"
  //     : "https://localpoint-dev-server-1c6c4ca64539.herokuapp.com",

  URL_SERVIDOR_SSE: "https://localpoint-dev-server-1c6c4ca64539.herokuapp.com",

  VALIDAR_UBICACION: process.env.VALIDAR_UBICACION || "0",

  URL_APLICACION: "",

  POLITICA_DE_PRIVACIDAD:
    process.env.POLITICA_DE_PRIVACIDAD ||
    "https://localpoint.com.ar/politica-de-privacidad/",
  CONDICIONES_DEL_SERVICIO:
    process.env.CONDICIONES_DEL_SERVICIO ||
    "https://localpoint.com.ar/politica-de-privacidad/",

  BASE_PATH: `${HttpHttps}://${SERVER_IP}`,
  BASE_API: `${HttpHttps}://${SERVER_IP}/api/v1`,

  VERSION: "1.6.2",

  Ping_ObtenerVersionBackEnd: "version",
  // Ping_IPtoLatLon: "https://ipecho.io/my",
  Ping_IPtoLatLon1: "https://ipinfo.io/ipPublica?token=18d8c3b1e6add3",

  API_ROUTES: {
    Idioma_Obtener: "idiomas?Activo=true",

    Localidad_ObtenerTodas: "localidades",
    Localidad_Obtener: "localidades?Activo=true",
    Localidad_Actualizar: "localidad",
    Localidad_Nuevo: "localidad",
    Localidad_Borrar: "localidad",

    ListaBlanca_ObtenerTodas: "listaBlancas",
    ListaBlanca_Obtener: "listaBlancas?Activo=true",
    ListaBlanca_Actualizar: "listaBlanca",
    ListaBlanca_Nuevo: "listaBlanca",
    ListaBlanca_Borrar: "listaBlanca",

    Texto_Obtener: "textos",

    Usuario_CrearCuenta: "userCrearCuenta",
    Usuario_ReenviarCodigoActivacion: "userReenviarCodigoActivacion",
    Usuario_ActivarCuenta: "userActivarCuenta",
    Usuario_GenerarCodigoRecuperacion: "userGenerarCodigoRecuperacion",
    Usuario_ValidarEmail: "userValidarEmail",
    Usuario_ValidarCodigoRecuperacion: "userValidarCodigoRecuperacion",
    Usuario_CambiarClave: "userCambiarClave",
    Usuario_Ingresar: "auth/ingresar",
    Usuario_IngresarConPasswordEncriptado: "auth/ingresarConPasswordEncriptado",
    Usuario_Obtener: "users",
    Usuario_ObtenerxEmail: "obtenerxEmail",
    Usuario_Actualizar: "user",
    Usuario_ActualizarAvatar: "userActualizarAvatar",
    Usuario_ActualizarTokenNotificacion: "userActualizarTokenNotificacion",
    Usuario_ActualizarTarjeta: "userActualizarTarjeta",
    Usuario_ActualizarTokenNotificacionConductor:
      "userActualizarTokenNotificacionConductor",
    Usuario_Importar: "nominaImportar",

    Empresa_ObtenerTodas: "empresas",
    Empresa_Obtener: "empresas?Activo=true",
    Empresa_Actualizar: "empresa",
    Empresa_Nuevo: "empresa",
    Empresa_Borrar: "empresa",

    Texto_Actualizar: "texto",
    Texto_Borrar: "texto",

    Email_Obtener: "emails",
    Email_Actualizar: "email",
    Email_Borrar: "email",
    Email_Enviar: "emailEnviar",

    Precio_ObtenerTodas: "precios",
    Precio_Obtener: "precios?Activo=true",
    Precio_Actualizar: "precio",
    Precio_Nuevo: "precio",
    Precio_Borrar: "precio",
    Precio_ObtenerPrecioBase: "obtenerPrecioBase",

    Subastador_ObtenerConductoresActivos: "users",
    Subastador_subastar: "subastar",

    Viaje_Nuevo: "viaje",
    Viaje_ObtenerActivos: "viajes",
    Viaje_Actualizar: "viaje",
    Viaje_HistorialDeViajes_Pasajero: "viajesConPeriodoPasajero",
    Viaje_MisViajes_Conductor: "viajesConPeriodoConductor",
    Viaje_ParaBancoOpg: "viajesParaBancoOpg",
    Viaje_ParaBancoRet: "viajesParaBancoRet",
    Viaje_ImportarResultadoBanco: "importarResultadoBanco",
    Viaje_refrescarHome: "refrescarHome",
    Viaje_refrescarHomePorToken: "refrescarHomePorToken",
    Viaje_calcularSaldoConductor: "calcularSaldoConductor",

    Conductor_Activar: "user",
    Conductor_ObtenerDisponible: "users",

    Pago_obtenerUltimosPagos: "obtenerUltimosPagos",

    GoogleRecaptchaV3_verificargoogleRecaptchaV3: "verificargoogleRecaptchaV3",

    // MOBBEXcrearCliente: "MOBBEXcrearCliente",
    // MOBBEXcrearTarjeta: "MOBBEXcrearTarjeta",
    // MOBBEXcrearRelacion: "MOBBEXcrearRelacion",
    // MOBBEXrealizarPago: "MOBBEXrealizarPago",

    MOBBEXcheckout: "MOBBEXcheckout",

    GEOLOCALIZACION_LatLonToDireccionPostal: "LatLonToDireccionPostal",
    GEOLOCALIZACION_LatLonToDireccionPostalGoogle:
      "LatLonToDireccionPostalGoogle",
    GEOLOCALIZACION_autocomplete: "autocomplete",
    GEOLOCALIZACION_autocompleteLabelId: "autocompleteLabelId",
  },
};
